module.exports = __webpack_public_path__ + "static/media/kpiqr.2490e90e.png";